import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { EmailCreateService } from '../../../services/email-create.service';

@Component({
  selector: 'tt-bulk-mail',
  templateUrl: './bulk-mail.component.html',
  styleUrls: ['./bulk-mail.component.css']
})
export class BulkMailComponent implements OnInit {
    bulkMailKeyno;

    public emailTemplateButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'emailtemplates' }];

    public emailTemplateEditButtons: FormButton[] = [
        { id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'emailtemplates' },
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'emailtemplate', gotoParms: () => this.edit!.emailtemplate_keyno ?? '' }
    ];

    public edit?: Edit;

    public selectListEmailTemplates: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private emailCreateService: EmailCreateService) {
        this.bulkMailKeyno = this.stateService.getStateParams()['bulkmail_keyno'];
    }

    private async loadEdit() {
        if (!!this.bulkMailKeyno) {
            this.edit = (await this.datatask.Post(3103, { bulkmail_keyno: this.bulkMailKeyno }))[0];
        }
    }

    private async loadEmailTemplates() {
        this.selectListEmailTemplates = await this.emailCreateService.getEmailTemplates({ webpage: 'bulkmail' });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3104, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadEmailTemplates();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    bulkmail_keyno: string;
    bulkmail_name: string;
    reg_by_portal_user: string;
    emailtemplate_keyno: string;
    emailtemplate_name: string;
}
